import { I18n } from '@/services/i18n';

type Message = {
  popular: string;
  save: string;
  best: string;
  tax: string;
  taxesIncluded: string;
  perDay: string;
};

const messages: I18n<Message> = {
  en: {
    popular: 'Most popular',
    save: 'Save',
    best: 'Best deal',
    tax: 'tax',
    taxesIncluded: 'All taxes included',
    perDay: 'per day',
  },
  es: {
    popular: 'Más popular',
    save: 'Ahorrar',
    best: 'Mejor oferta',
    tax: 'impuesto',
    taxesIncluded: '',
    perDay: 'por día',
  },
  de: {
    popular: 'Am beliebtesten',
    save: 'Sparen',
    best: 'Bestes Angebot',
    tax: 'Steuer',
    taxesIncluded: 'Alle Steuern inbegriffen',
    perDay: 'pro Tag',
  },
};

export { messages };
